import {Pipe, PipeTransform} from '@angular/core';
import {limitText} from '../../utils/string.utils';

@Pipe({name: 'limit'})
export class LimitPipe implements PipeTransform {
    transform(input: string, limit: number, hasEllipsis = true): string {
        return limitText(input, limit, hasEllipsis);
    }
}
